export { hooks, setHookCallback };

var hookCallback;

function hooks() {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback(callback) {
    hookCallback = callback;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/moment/src/lib/utils/hooks.js
// module id = 25
// module chunks = 1